import { IconClock, IconCalendar, IconTrash, IconHeadset, IconCheck } from '@tabler/icons-react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { AdvisoryLead } from '../models/dashboardModels';
import { toAdvisoryStatusCounts } from '../adapters/advisoryAdapters';

interface Props {
  leads: AdvisoryLead[];
  // Total real (todas las páginas), de `advisoryPaginator.itemCount` — el
  // desglose por status de abajo sí es sólo de la página cargada (Advisory
  // no tiene endpoint de métricas), así que el total no puede salir de
  // sumar esos mismos `leads` o quedaría desalineado con el contador del
  // tab en NavigationTabDashboard, que sí usa el total real.
  totalCount: number;
}

// Mismo look que MetricsDashboard.tsx (los cards de Renta/Secondary/PreVenta)
// — acá el desglose por status se calcula client-side sobre la página
// cargada, no viene de un endpoint de métricas (Advisory no tiene uno).
const AdvisoryMetricsDashboard = ({ leads, totalCount }: Props) => {
  const stats = toAdvisoryStatusCounts(leads);

  return (
    <Row>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-primary">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Asesorías</h6>
                <h2 className="mb-0 text-primary">{totalCount}</h2>
              </div>
              <IconHeadset size={24} className="text-primary" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-warning">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Pendiente de aprobación</h6>
                <h2 className="mb-0 text-warning">{stats.pending_approval}</h2>
              </div>
              <IconClock size={24} className="text-warning" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-info">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Programada</h6>
                <h2 className="mb-0 text-info">{stats.scheduled}</h2>
              </div>
              <IconCalendar size={24} className="text-info" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-warning">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Re programada</h6>
                <h2 className="mb-0 text-warning">{stats.rescheduled}</h2>
              </div>
              <IconCalendar size={24} className="text-warning" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-danger">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Cancelada</h6>
                <h2 className="mb-0 text-danger">{stats.cancelled}</h2>
              </div>
              <IconTrash size={24} className="text-danger" />
            </div>
          </CardBody>
        </Card>
      </Col>
      <Col lg={2} md={4} sm={6} className="mb-3">
        <Card className="border-success">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1">Finalizada</h6>
                <h2 className="mb-0 text-success">{stats.finished}</h2>
              </div>
              <IconCheck size={24} className="text-success" />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AdvisoryMetricsDashboard;
